import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { SubGroupQueries } from '@/services/groupsManagement/subGroups.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageSubGroupClubStatus = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation('manageSubGroupClubStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: SubGroupQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useManageSubGroupClubStatus;
